import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=050852b6&"
import script from "./Enquiries.vue?vue&type=script&lang=js&"
export * from "./Enquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports